import { ButtonSkeleton, CardSkeleton } from '@/components/shared/skeleton'

export const UserInviteSkeleton = () => (
  <div className="mx-40 mb-40 flex h-full flex-col justify-between lg:mx-24 xxs:mx-16 xxs:mb-16">
    <div>
      <ButtonSkeleton className="mb-24 h-[28px] w-[171px] xxs:mb-20" />
      <ButtonSkeleton className="mb-32 h-56 w-full xxs:mb-20 xxs:h-44" />
      <CardSkeleton className="h-[317px] w-full rounded-24 xxs:h-[211px]" />
    </div>
    <ButtonSkeleton className="h-56 w-full xxs:h-44" />
  </div>
)
